import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { TaxCoupon } from '@/store/NFE/type';
import { ChurnContactStatus } from '@/store/Churn/types';
import { RECAPTCHA_HEADER } from '@/hooks/useRecaptcha';
import { useRequiredRecaptchaToken } from '@/contexts/Recaptcha';
import api from '../../../services/api';
import { ISearchData } from '../../../pages/Sale/ListSale/types';
import queryClient from '../../queryClient';
import { QUERY_EXCEL_EXPORT } from '../GetExcel/useExcelExport';

export type ReportType =
    | 'sales'
    | 'sales-by-transaction'
    | 'product-global'
    | 'product'
    | 'planogram'
    | 'invoice'
    | 'churn-monitoring'
    | 'category'
    | 'stockout-report'
    | 'totem'
    | 'planogram-turnover'
    | 'inventory-detailed'
    | 'planogram-automation';

export interface PropsExcel extends ISearchData {
    optionalDataFilter?: string;
    filters?: {
        stores?: number[];
        categories?: number[];
        product?: string;
        barCode?: string;
    };
    group?: string[] | null;
    startDate?: string;
    endDate?: string;
    status?: TaxCoupon | ChurnContactStatus;
    query?: string;
    orderDir?: 'asc' | 'desc';
    orderBy?: string;
    name?: string;
    isForLegalAge?: string;
    doc?: string;
    plugpagEmail?: string;
    splitStatus?: string;
    splitType?: string;
    totemId?: number;
    shopmanagerId?: number;
    reportType?: ReportType;
    inventoryId?: number;
}

const createExcellExportFetch = async (data: PropsExcel, reCaptcha: string) => {
    const response = await api.post(
        `/reports/v2/export-xlsx`,
        {
            ...data,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        { headers: { [RECAPTCHA_HEADER]: reCaptcha } },
    );
    return response.data;
};

export const useCreateExcel = () => {
    const getRecaptchaToken = useRequiredRecaptchaToken();

    return useMutation({
        mutationFn: async (data: PropsExcel) =>
            createExcellExportFetch(data, await getRecaptchaToken()),
        onError: (error: AxiosError) => error,
        onSuccess: () => queryClient.invalidateQueries([QUERY_EXCEL_EXPORT]),
    });
};
